<template>
  <div class="inner_content">
    <div class="header">
      <div class="box flex" style="align-items:center">
        <el-button type="primary" size="small" @click="dialogVisible = true"
          >添加洗车门店</el-button
        >
      </div>
    </div>
    <div class="bottom">
      <el-table
        :data="listData"
        size="small"
        :header-cell-style="setHeader"
        height="100%"
      >
        <el-table-column label="洗车门店名称" prop="name"></el-table-column>
        <el-table-column label="门店类型" prop="shopType"></el-table-column>
        <el-table-column label="电话" prop="mobile"></el-table-column>
        <el-table-column label="地址" prop="address"></el-table-column>
        <el-table-column label="创建时间" prop="show"></el-table-column>
        <el-table-column width="465px" label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.type == 1"
              type="text"
              slot="reference"
              @click="editors(scope.row.id)"
              >编辑</el-button
            >
            <el-button
              type="text"
              slot="reference"
              @click="$router.push('index?type=' + scope.row.id)"
              >门店项目</el-button
            >
            <el-button
              type="text"
              slot="reference"
              @click="$router.push('employee?type=' + scope.row.id)"
              >店员管理</el-button
            >
            <el-button
              type="text"
              slot="reference"
              @click="$router.push('order?room_id=' + scope.row.id)"
              >洗车订单</el-button
            >
            <el-button
              type="text"
              slot="reference"
              @click="option(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next, jumper"
        :total="total_num"
      >
      </el-pagination>
    </div>
    <!--  -->
    <el-dialog
      title="选择创建门店类型"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <el-radio-group v-model="shopType">
        <el-radio-button label="1">自营</el-radio-button>
        <el-radio-button label="2">合作门店</el-radio-button>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="choseType">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择创建门店类型" :visible.sync="dialogShop" width="30%">
      <el-radio-group v-model="platformType">
        <el-radio-button
          :label="item.id"
          border
          v-for="(item, index) in shopList"
          :key="index"
          >{{ item.name }}</el-radio-button
        >
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShop = false">取 消</el-button>
        <el-button type="primary" @click="chosePlatform">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { indexRoomWash, delRoomWash, addRoomWash } from "@/api/carWash";
import { storeList } from "@/api/storeManage";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "status"]),
  },
  inject: ["reload"],
  data() {
    return {
      shopType: "1", //1 z自营 2合作门店
      dialogVisible: false,
      dialogShop: false, //自营店铺选择
      shopList: [], //店铺列表
      platformType: "", //平台店铺选择
      page: "1",
      total_num: 0,
      listData: [],
      dialogFormVisible: false,
      value1: "",
      value: "",
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000",
      },
    };
  },
  mounted() {
    this.getLists();
    this.shopLists();
    // let m, b, c;
    // console.log("数据", m, b, c);
    // a = function() {
    //   console.log("a", "eee");
    // };
    // function a() {
    //   console.log("a", "2222");
    // }

    // a();
    a = 23;
    var a = 11;
    console.log("a", a);
  },
  methods: {
    shopLists() {
      let data = {
        token: this.token,
        app_id: this.app_id,
      };
      storeList(data).then((res) => {
        console.log("店铺列表", res);
        this.shopList = res.data;
      });
    },
    chosePlatform() {
      if (!this.platformType) {
        this.$message.warning("请选择一个店铺！！");
        return;
      } else {
        //
        let data = {
          token: this.token,
          app_id: this.app_id,
          type: 0,
          room_id: this.platformType,
        };
        addRoomWash(data).then((res) => {
          if (res.code == 200) {
            this.reload();
            this.dialogVisible = false;
            this.dialogShop = false;
            this.$message.success("创建店铺成功！！");
          }
        });
      }
    },
    choseType() {
      if (this.shopType == 2) {
        this.$router.push("adShop");
      } else {
        this.dialogShop = true;
      }
    },
    downloadQrcode(id, type = 1) {
      console.log("id", id);

      let params = {
        service_id: id,
        token: this.token,
        app_id: this.app_id,
      };
      var param =
        "?token=" + this.token + "&app_id=" + this.app_id + "&service_id=" + id;
      if (type == 1) {
        //关注收款码
        var url1 =
          "https://www.58zltc.com/service/agent.index/h5_downLoad" + param;
        if (this.status == "test") {
          url1 =
            "https://cs.58zltc.com/service/agent.index/h5_downLoad" + param;
        }
        window.location.href = url1;
      } else if (type == 2) {
        //微信码
        var url1 =
          "https://www.58zltc.com/service/agent.index/wxapp_downLoad" + param;
        if (this.status == "test") {
          url1 =
            "https://cs.58zltc.com/service/agent.index/wxapp_downLoad" + param;
        }
        window.location.href = url1;
      } else if (type == 3) {
        //支付宝小程序码
        var url1 =
          "https://www.58zltc.com/service/agent.index/aliapp_downLoad" + param;
        if (this.status == "test") {
          url1 =
            "https://cs.58zltc.com/service/agent.index/aliapp_downLoad" + param;
        }
        window.location.href = url1;
      }
    },
    downloadImg() {
      // var img = document.getElementById("testImg"); // 获取要下载的图片
      // var url = img.src; // 获取图片地址
      // var a = document.createElement("a"); // 创建一个a节点插入的document
      // var event = new MouseEvent("click"); // 模拟鼠标click点击事件
      // a.download = "图片名字"; // 设置a节点的download属性值
      // a.href =
      //   "https://yckj-common.oss-cn-beijing.aliyuncs.com/1595412779.jpg"; // 将图片的src赋值给a节点的href
      // // a.href = url; // 将图片的src赋值给a节点的href
      // a.dispatchEvent(event); // 触发鼠标点击事件
    },
    // 设置表头颜色
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    editors(id) {
      //
      this.$router.push({ path: "adShop", query: { type: 1, idE: id } });
    },
    option(Oid) {
      let data = {
        token: this.token,
        app_id: this.app_id,
        id: Oid,
      };
      this.$confirm("确定要删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delRoomWash(data).then((res) => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.reload();
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
        .catch();
    },
    //服务
    getLists() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
      };
      indexRoomWash(data).then((res) => {
        if (res.code == 200) {
          this.listData = res.data.result;
          this.total_num = res.data.total_num;
          for (var i = 0; i < this.listData.length; i++) {
            this.listData[i].shopType =
              this.listData[i].type == 0 ? "自营门店" : "合作门店";
            this.listData[i].verify =
              this.listData[i].is_verify == 1 ? "是" : "否";
            this.listData[i].show = this.listData[i].status == 1 ? "是" : "否";
          }
        } else {
          this.$message.warning(res.msg);
        }
        console.log("列表", res);
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getLists();
    },
  },
};
</script>
<style lang="scss" scoped>
.inner_content {
  height: 100%;
  background: #fff;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  .header {
    padding-top: 20px;
    margin-bottom: 20px;
    .box {
      width: 330px;
      .title {
        min-width: 50px;
        text-align: right;
      }
      .fixedwidth {
        width: 180px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .bottom {
    flex: 1;
    overflow-y: scroll;
  }
  .page {
    height: 50px;
    display: flex;
    align-items: center;
  }
}
// 通用样式
.flex {
  display: flex;
  align-items: center;
  padding: 10px 0px;
}
</style>
